export const stripTrailingSlash = (str: string) => str.replace(/\/$/, '');
